// extracted by mini-css-extract-plugin
export var columnList = "_df-0";